<script setup lang="ts">
const { navigateToFilters } = useSearchNavigateToFilters()
const { filters, showModalFilters } = storeToRefs(useSearchStore())

const onModalClose = async () => {
  showModalFilters.value = false
  await navigateToFilters()
}

const isAtLeastOneFilterActive = computed(() => {
  return !!Object.values(filters.value).find(f => (Array.isArray(f) ? f.length > 0 : !!f))
})
</script>

<template>
  <button
    class="rounded border bg-white border-gray-300 text-gray-500"
    :aria-label="$t('components.app_search.filters.button_label')"
    @click="showModalFilters = true"
  >
    <YscIconsPreferencesSelected
      v-if="isAtLeastOneFilterActive"
      highlight="text-pink-500"
      class="mx-4 my-4 h-6 w-6 shrink-0 text-gray-400"
    />
    <YscIconsPreferencesUnselected
      v-else
      class="mx-4 my-4 h-6 w-6 shrink-0 text-gray-400"
    />
  </button>

  <AppModalSearchFilters
    v-if="showModalFilters"
    class="!z-[80] block md:hidden"
    show
    @close="onModalClose"
  />
</template>
